export default function initStyles() {
  const bgColors = document.querySelectorAll<HTMLElement>('.js-bg-color');
  bgColors.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.backgroundColor = el.dataset.bgColor as string;
  });

  const objectPosition = document.querySelectorAll<HTMLElement>('.js-object-position');
  const isTouchDevice = /iPad|iPhone|iPod|Android/.test(navigator.userAgent);
  objectPosition.forEach((el) => {
    // eslint-disable-next-line no-param-reassign
    el.style.objectPosition = el.dataset.objectPosition as string;
    const { objectPositionMobile } = el.dataset;
    if (objectPositionMobile && isTouchDevice) {
      // eslint-disable-next-line no-param-reassign
      el.style.objectPosition = objectPositionMobile;
    }
  });
}
